/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react';
import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';
import { ActiveShape, CustomizedLabel, InnerActiveShape } from './components';

const RADII = {
  inner: '30%',
  middleOverlap: '41%',
  middle: '40%',
  outer: '70%',
};

const SMALL_RADII = {
  inner: '20%',
  middleOverlap: '31%',
  middle: '30%',
  outer: '50%',
};

export type DonutChartDataInput = {
  name: string;
  value: number;
  percent: number;
}[];

const DonutChart = (props: {
  data: DonutChartDataInput;
  colors: string[];
  innerColors: string[];
  small?: boolean;
}): JSX.Element => {
  const [activeIndex, setActiveIndex] = useState<number>(0);

  const onPieEnter = (data: any, index: number): void => {
    setActiveIndex(index);
  };

  const radii = props.small ? SMALL_RADII : RADII;

  const renderChart = (): JSX.Element => {
    return (
      <ResponsiveContainer>
        <PieChart>
          <Pie
            activeIndex={activeIndex}
            activeShape={(p: any) => InnerActiveShape({ ...p, small: props.small })}
            data={props.data}
            innerRadius={radii.inner}
            outerRadius={radii.middleOverlap}
            fill="#8884d8"
            dataKey="value"
            onMouseEnter={onPieEnter}
            isAnimationActive={false}
          >
            {props.data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                strokeWidth={0}
                fill={props.innerColors[index % props.innerColors.length]}
              />
            ))}
          </Pie>
          <Pie
            activeIndex={activeIndex}
            activeShape={(p: any) =>
              ActiveShape({ ...p, data: props.data, activeIndex, small: props.small })
            }
            data={props.data}
            innerRadius={radii.middle}
            outerRadius={radii.outer}
            fill="#8884d8"
            dataKey="value"
            onMouseEnter={onPieEnter}
            isAnimationActive={false}
            label={(p: any) =>
              CustomizedLabel({ ...p, activeIndex, data: props.data, small: props.small })
            }
          >
            {props.data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                strokeWidth={0}
                fill={props.colors[index % props.colors.length]}
              />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    );
  };

  return <div className="chart-container">{renderChart()}</div>;
};

export default DonutChart;
